import PropTypes from "prop-types";
import React from "react";
import colors from "styles/colors";
import styled from "styled-components";

const Section = ({ children, className, padding, margin, radius, width, onClick, bgColor, boxShadow }) => {
  return (
    <StyledSection
      className={className}
      padding={padding}
      margin={margin}
      radius={radius}
      width={width}
      onClick={onClick}
      bgColor={bgColor}
      boxShadow={boxShadow}
    >
      {children}
    </StyledSection>
  );
};

Section.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  padding: PropTypes.string,
  margin: PropTypes.string,
  radius: PropTypes.string,
  width: PropTypes.string,
  onClick: PropTypes.func,
  bgColor: PropTypes.string,
  boxShadow: PropTypes.string,
};

export default Section;

const StyledSection = styled.div.attrs((props) => ({
  padding: props.padding || "16px",
  margin: props.margin || "0 0 16px",
  radius: props.radius || "10px",
  width: props.width,
  bgColor: props.bgColor || colors.backgroundSection,
  boxShadow: props.boxShadow || colors.sectionShadow + " 0 10px 30px",
}))`
  background-color: ${(props) => props.bgColor};
  border-radius: ${(props) => props.radius};
  margin: ${(props) => props.margin};
  padding: ${(props) => props.padding};
  width: ${(props) => props.width};
  box-shadow: ${(props) => props.boxShadow};
`;
